/**
 * App Constants
 */

export default {
   //App logo
   AppLogo: require('../assets/images/header-logo.png'),

   //algolia configuration
   algoliaConfig: {
      appId: 'latency',
      apiKey: '3d9875e51fbd20c7754e65422f7ce5e1',
      indexName: 'bestbuy'
   },

   cognitoConfig: {
       UserPoolId: 'us-east-1_1q72idAwW',
       ClientId: '5vvkojcgaeu6iqcgc3i0pego1a',
       region: 'us-east-1',
       IdentityPoolId: 'us-east-1:d1eba917-87ff-494e-aecb-69afc986cecf',
   },

   // default locale
   locale: {
      locale: 'en',
      name: 'English',
      icon: 'en',
   },

   //footer about description
   AboutUs: 'We just wanted to create a site to help people get a hold of used Tesla, plus increase the adaption of Electric vehicles  ',

   // Copyright text
   CopyrightText: 'Made with love from Louisville, KY'
}


// WEBPACK FOOTER //
// ./src/constants/AppConfig.js